import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import CustomAdapter from './adapter';

/** 
 * @extends module:core/plugin~Plugin
 */
export default class UploadAdapter extends Plugin {
	/**
	 * @inheritDoc
	 */
	init() {            
		this.editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
            return new CustomAdapter(loader, this.editor.config.get('uploadAdapter.backendUrl'));
        };
	}
}
